/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Paused_TitleInputs */

const en_us2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout paused`)
};

const pt_br2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino pausado`)
};

const es_419_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento en pausa`)
};

const pt_pt2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino em pausa`)
};

const fr_fr2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance en pause`)
};

const de_de2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training pausiert`)
};

const it_it2_workout_live_paused_title = /** @type {(inputs: Workout_Live_Paused_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento in pausa`)
};

/**
* | output |
* | --- |
* | "Workout paused" |
*
* @param {Workout_Live_Paused_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_paused_title = /** @type {((inputs?: Workout_Live_Paused_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Paused_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_paused_title(inputs)
	if (locale === "es-419") return es_419_workout_live_paused_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_paused_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_paused_title(inputs)
	if (locale === "de-DE") return de_de2_workout_live_paused_title(inputs)
	if (locale === "it-IT") return it_it2_workout_live_paused_title(inputs)
	return en_us2_workout_live_paused_title(inputs)
});
export { workout_live_paused_title as "workout-live.paused_title" }